import { NICmsContentComponent } from '@icms/core/content';
import { NPageHeader } from '../../../../layout/page/header/page-header.interface';

export namespace NProductLayout {
    export interface IContent extends NICmsContentComponent.IData, NPageHeader.IVersionConfig {
        mediaLayout: EMediaLayout;
        /**
         * Whitelisted media roles
         */
        requiredMediaLabels?: string;
        /**
         * Disallowed media roles
         */
        bannedMediaLabels?: string;
        /**
         * Bottom components list
         */
        bottomComponents: NICmsContentComponent.IData[];
        /**
         * Allow financing tray
         */
        allowFinancingTray: boolean;
        /**
         * Product details attributes to display
         */
        detailsAttributes: IDetailsAttribute[];
        /**
         * Furniture details attributes to display
         */
        furnitureDetails: IDetailsAttribute[];
        /**
         * Return details
         */
        returnNote?: string;
        returnLinkText?: string;
        returnLink?: string;
        /**
         * Gift boxing
         */
        giftBoxing?: IGiftCopy[];
        giftBoxingImage?: string;
    }

    export enum EMediaLayout {
        scroll = 'scroll',
        grid = 'grid'
    }

    export interface IDetailsAttribute {
        heading: string;
        bulletPoints?: boolean;
        attributes: IAttribute[];
    }

    export interface IAttribute {
        type: 'attribute' | 'property';
        code?: string;
        codeManual?: string;
        mode: EAttributeMode;
    }

    export enum EAttributeMode {
        cms = 'cms',
        attributeTitleValue = 'attributeTitleValue',
        attributeValue = 'attributeValue'
    }

    export interface IGiftCopy {
        copy?: string;
    }
}
